/**
 * Factorial helper
 * @param num
 * @returns {number}
 */
export  let factorial = num => num === 0 ? 1 : (num * factorial( num - 1 ));



// WEBPACK FOOTER //
// factorial.js